import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Option, StackedRadioCardGroup } from 'components/Forms';
import { Heading, Paragraph } from 'components/Typography';
import { TypeScreenerQuestionV2 } from 'types/contentful';
import { splitQuestionAnswers } from 'domains/signup/screener/data/questions';

type Props = {
  question: TypeScreenerQuestionV2;
  currentResponse: string | undefined;
  submitResponse: (response: string) => void;
};

const ScreenerQuestion: React.FC<Props> = ({
  question: {
    fields: { possibleAnswers, question: questionText, helpText },
  },
  currentResponse,
  submitResponse,
}) => {
  const { t } = useTranslation();

  const options: Option[] = useMemo(
    () =>
      splitQuestionAnswers(possibleAnswers).map(
        value =>
          ({
            value,
            label: t(`screener.questions.answersLabel.${value}`),
          } as Option),
      ),
    [possibleAnswers, t],
  );

  return (
    <div>
      <Heading level="h2">{questionText}</Heading>
      <Paragraph className="mt-16">{helpText}</Paragraph>

      <StackedRadioCardGroup
        label={t('screener.questions.singleSelectTitle')}
        className="gap-14 mt-64 sm-d:mt-40"
        disabled={false}
        showSelectedDot
        options={options}
        value={currentResponse}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => submitResponse(e.target.value)}
        name={`responses-${questionText}`}
        clearValue={noop}
        setError={noop}
        setValue={noop}
      />
    </div>
  );
};

export default ScreenerQuestion;
